import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Alert, Box, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import * as invoicesApi from '@/api/invoices';
import { toApiError } from '@/api/client';
import { LoadingScreen } from '@/components/LoadingScreen';
import { IssueInvoiceDialog } from '@/components/IssueInvoiceDialog';
import { useCurrentCuit } from '@/auth/CuitContext';

export const Route = createFileRoute('/_authenticated/invoices/$id/edit')({
  component: EditInvoiceDraftPage,
});

function EditInvoiceDraftPage(): JSX.Element {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { currentCuitProfileId } = useCurrentCuit();
  const draftQ = useQuery({
    queryKey: ['invoice', id, currentCuitProfileId],
    queryFn: () => invoicesApi.getInvoice(id, currentCuitProfileId),
    enabled: Boolean(id),
  });

  if (draftQ.isLoading) return <LoadingScreen message="Cargando borrador…" />;

  if (draftQ.isError || !draftQ.data) {
    return (
      <Box sx={{ maxWidth: 720, mx: 'auto' }}>
        <Button startIcon={<ArrowBack />} onClick={() => navigate({ to: '/invoices' })} sx={{ mb: 2 }}>
          Volver
        </Button>
        <Alert severity="error">
          {draftQ.error ? toApiError(draftQ.error).message : 'No se pudo cargar el borrador.'}
        </Alert>
      </Box>
    );
  }

  if (draftQ.data.status !== 'Draft') {
    return (
      <Box sx={{ maxWidth: 720, mx: 'auto' }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate({ to: '/invoices/$id', params: { id } })}
          sx={{ mb: 2 }}
        >
          Volver al comprobante
        </Button>
        <Alert severity="info">Este comprobante ya no está en borrador y no se puede editar.</Alert>
      </Box>
    );
  }

  return (
    <IssueInvoiceDialog
      open
      draft={draftQ.data}
      onClose={() => void navigate({ to: '/invoices/$id', params: { id } })}
      onDraftSaved={() => void draftQ.refetch()}
    />
  );
}
